// removed by extract-text-webpack-plugin
module.exports = {"standard_disclaimer":"StandardDisclaimer--standard_disclaimer--2SLri","standard_disclaimer_print":"StandardDisclaimer--standard_disclaimer_print--3tAEo","logo":"StandardDisclaimer--logo--qlins","logo_link":"StandardDisclaimer--logo_link--2-kU_","logo_image":"StandardDisclaimer--logo_image--37ryF","legal":"StandardDisclaimer--legal--9_gc8","disclaimer":"StandardDisclaimer--disclaimer--1OOlM","copyright":"StandardDisclaimer--copyright--1Wcl7"};


//////////////////
// WEBPACK FOOTER
// /src/~/@healthwise/enhanced-shared-decision-point/components/StandardDisclaimer/StandardDisclaimer.css
// module id = 1033
// module chunks = 0